let pdfBtn = document.querySelector('.handle-pdf');

async function createPdf(blob,opt) {
    const pngImageBytes = await blob.arrayBuffer()
    const pdfDoc = await PDFLib.PDFDocument.create()
    const pngImage = await pdfDoc.embedPng(pngImageBytes)
    const pngDims = pngImage.scale(0.5)
    const page = pdfDoc.addPage()
    page.setSize((pngDims.width/2)-10,pngDims.height/2);
    page.drawImage(pngImage, {
        x:-10,
      width: pngDims.width/2,
      height: pngDims.height/2,
    })
    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], {type: 'application/pdf'});
    const blobURL = URL.createObjectURL(pdfBlob);
    saveAs(blobURL,opt.filename);
  }

const handlePdf = function(event){

    //Show toast
    showToast(pdf_processing_message);

    const opt = {
        filename:`${event.currentTarget.getAttribute('data-title')}.pdf`
    };
    const ignoreClasses = ["read-more-wrap","date-action","kg-embed-card"];
    var config= {
        useCORS: true,
        ignoreElements: function (element) {
            let retStatus = false;
            if(element.className && typeof element.className == "string"){
                if(ignoreClasses){
                    ignoreClasses.forEach(el => {
                        if(element.className.includes(el)){
                            retStatus = true;
                        }
                    })
                }
            }
            return retStatus;
        }
    };

    //Print labels
    const printLabel = document.querySelector('.print-label');
    if(printLabel){ printLabel.style.display="block";}

    html2canvas(document.querySelector('.site-main'),config).then(function(canvas) {
        canvas.toBlob(function(blob) {
            createPdf(blob,opt)
        });
    }).then(function(){
        if(printLabel){printLabel.style.display="none";}
    });
};
if(pdfBtn)
pdfBtn.addEventListener('click', handlePdf);